import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const APP_URL = "https://app.pipeguide.tech";
export const REGISTER_URL = `${APP_URL}/register`;
export const LOGIN_URL = `${APP_URL}/login`;
export const DEMO_URL = `${APP_URL}/demo`;

// Flip to true once the product app at app.pipeguide.tech is deployed.
// When false: every "Start Free" / "Sign in" CTA opens the Early-Access demo modal instead.
export const PRODUCT_LIVE = true;
